const filters = document.querySelectorAll('.realisations-filter__item');
const grid = document.querySelector('.realisations-list');
const loadMore = document.querySelector('#load-more');
let paged = 1;

const mansonry = new Masonry(grid, {
  itemSelector: '.realisations-list__item',
  columnWidth: '.realisations-list__item',
  gutter: 20,
  initLayout: true,
});

const setActiveFilter = (active) => {
  filters.forEach((filter) => {
    filter === active
      ? filter.setAttribute('aria-checked', 'true')
      : filter.setAttribute('aria-checked', 'false');
  });
};

const getRealisations = async (slug, page) => {
  jQuery.ajax({
    type: 'POST',
    url: '/wp-admin/admin-ajax.php',
    dataType: 'html',
    data: {
      action: 'get_realisations',
      slug: slug,
      page: page,
    },
    success: function (response) {
      response = JSON.parse(response);
      response.html.forEach((realisation) => {
        const parser = new DOMParser();
        const html = parser.parseFromString(realisation, 'text/html');
        const item = html.querySelector('.realisations-list__item');
        grid.appendChild(item);
      });
      mansonry.reloadItems();
      mansonry.layout();
      loadMore?.setAttribute('data-max', response.max);
    },
  });
};

filters.forEach((filter) => {
  filter.addEventListener('click', () => {
    const slug = filter.dataset.slug;
    const state = filter.getAttribute('aria-checked') === 'true';
    if (state) return;

    setActiveFilter(filter);
    grid.innerHTML = '';
    loadMore?.classList.remove('realisations__loadmore--hidden');
    paged = 1;
    getRealisations(slug, 1);
  });
});

// the load more is launched when the user see the loader in the viewport
const loadMoreObserver = new IntersectionObserver((entries) => {
  if (entries[0].isIntersecting) {
    const slug = document.querySelector(
      '.realisations-filter__item[aria-checked="true"]'
    ).dataset.slug;
    const max = loadMore.dataset.max;

    loadMore.classList.add('realisations__loadmore--anim');

    setTimeout(() => {
      if (paged + 1 <= max) {
        paged += 1;
        getRealisations(slug, paged);
        loadMore.classList.remove('realisations__loadmore--anim');
      } else {
        loadMore.classList.add('realisations__loadmore--hidden');
      }
    }, 1500);
  }
});

loadMoreObserver.observe(loadMore);
